import { render, staticRenderFns } from "./odoo-obligor-limit.vue?vue&type=template&id=1d3a4c2b&scoped=true&"
import script from "./odoo-obligor-limit.vue?vue&type=script&lang=js&"
export * from "./odoo-obligor-limit.vue?vue&type=script&lang=js&"
import style0 from "./odoo-obligor-limit.vue?vue&type=style&index=0&id=1d3a4c2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3a4c2b",
  null
  
)

export default component.exports